module.exports = __webpack_public_path__ + "img/modal_welcome.59b53947.png";